// Product recommendations (<product-recommendations>). O elemento nasce
// vazio e busca a própria seção já renderizada pela Product
// Recommendations API, que é o caminho que a Shopify documenta: a
// recomendação depende de dados que só existem no servidor.
//
// Nada de esperar clique ou rolagem para pedir: o bloco fica logo abaixo
// do produto e chegar vazio quando a pessoa rola é pior que uma
// requisição de baixa prioridade no carregamento.

class ProductRecommendations extends HTMLElement {
  async connectedCallback() {
    const url = this.dataset.url;
    // Já renderizado pelo servidor (é o caso quando a própria API pede a
    // seção de volta): não há o que buscar.
    if (!url || this.querySelector('.product-rail')) return;

    this.controller = new AbortController();

    try {
      const response = await fetch(url, { signal: this.controller.signal });
      if (!response.ok) throw new Error(response.statusText);

      const fresh = new DOMParser()
        .parseFromString(await response.text(), 'text/html')
        .querySelector('product-recommendations');

      // Sem recomendação a seção volta vazia, e aí não se põe nada na
      // página: um trilho vazio com título é pior que ausência.
      if (fresh?.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
    } catch (error) {
      // Recomendação é enfeite: falhar em silêncio é a resposta certa.
      if (error.name !== 'AbortError') this.remove();
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
